<template>
    <div class="match-info-view body-item ">
        <div class="title"></div>

        <div class="m-time-line">
            <div class="slogen"></div>

            <div class="container">
                <div class="the-line">
                    <div class="line-bg"></div>
                    <ul class="line-list">
                        <li v-for="(item,index) in timeline" :key="index" :class="{'act' : item.state == 1}">
                            <div class="content">
                                <p class="time">{{ crtTimeFtt(item.startTime) }} ~ {{ crtTimeFtt(item.endTime) }}</p>
                                <div class="icon"></div>
                                <div class="name">
                                    {{ item.name }}
                                    <span class="status" :class="'status-' + item.state "></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="m-match-place">
            <div class="slogen"></div>
            <div class="container">
                <div class="place-item p-1"></div>
                <div class="place-item p-2"></div>
            </div>
            <div class="links">
                <div class="u-btn link-place"><a href="https://www.m3guo.com/v2/news/report/1646991850.html" target="_blank" rel="noopener noreferrer"></a></div>
                <div class="u-btn link-rule"><a href="https://www.m3guo.com/v2/news/report/1646991187.html" target="_blank" rel="noopener noreferrer"></a></div>
            </div>
        </div>

        <div class="match-team-img">
            <div class="slogen"></div>
            <div class="img"></div>
        </div>   
    </div>
</template>

<style scoped>

    .match-info-view{
        width: 100%;
        height: 1920px;
        margin: 0 auto;
        padding-top: 40px;
        background-image: url(~@/assets/images/bg-match-info.jpg); 
        background-position: center;
        background-repeat: no-repeat;
        box-sizing: border-box;  
    }

    .title{
        width: 1113px;
        height: 363px;
        margin: 0 auto;
        background-image: url(~@/assets/images/title-1.png);
    }

    .m-time-line{
        margin-top: 65px;
    }

    .m-time-line .slogen{
        width: 457px;
        height: 27px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/slogen-1.png);        
    }

    .m-time-line .container{
        position: relative;
        z-index: 1;
        height: 200px;        
    }

    .the-line{
        width: 1362px;
        height: 1px;
        position: absolute;
        top: 81px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1;        
    }

    .line-bg{
        width: 1362px;
        height: 1px;
        position: relative;
        overflow: hidden;
        z-index: 1;
        background-color: #ba8d52;        
    }

    .line-list{
        width: 100%;
        height: 165px;
        position: absolute;
        top: 0px;
        left: 0;        
    }

    .line-list::after{
        content: '';
        display: block;
        position: absolute;
        left: -1px;
        top: -19px;
        width: 1px;
        height: 37px;
        background-color: #b28850;
    }    

    .line-list li{
        position: relative;
        float: left;
        width: 454px;
        height: 60px;
        text-align: center;
    }

    .line-list li::after{
        content: '';
        display: block;
        position: absolute;
        right: -1px;
        top: -19px;
        width: 1px;
        height: 37px;
        background-color: #b28850;
    }

    .line-list .content{
        margin-top: -50px;
    }

    .line-list .act .content{
        margin-top: -80px;
    }

    .line-list .icon{
        width: 30px;
        height: 30px;
        margin: 0 auto 0;
        background-image: url(~@/assets/images/icon-match-off.png);  
    }

    .line-list .act .icon{
        position: relative;
        width: 54px;
        height: 54px;
        margin: 0 auto 0;
        background-image: url(~@/assets/images/icon-match-on.png);
        z-index: 5; 
    }

    .line-list .act .icon::after{
        content: '';
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        width: 212px;
        height: 212px;
        background-image: url(~@/assets/images/layer-light.png); 
        transform: translate(-50%,-50%);
    }

    .line-list .name{
        margin-top: 23px;
        font-size: 20px;
        color: #ba8d52;
    }

    .line-list .act .name{
        margin-top: 10px;
        color: #fbca55;
    }

    .line-list .time{
        margin-bottom: 16px;
        font-size: 14px;
        color: #ba8d52;
    }

    .line-list .act .time{
        margin-bottom: 26px;
        font-size: 20px;
        color: #b28850;        
    }
    
    .status{
        display: inline-block;
        width: 81px;
        height: 23px;
        vertical-align: sub;      
    }

    .status.status-0{
        background-image: url(~@/assets/images/status-0.png); 
    }

    .status.status-1{
        background-image: url(~@/assets/images/status-1.png); 
    }
    
    .status.status-2{
        background-image: url(~@/assets/images/status-2.png); 
    }    

    .m-match-place .slogen{
        width: 457px;
        height: 27px;
        margin: 0 auto;
        background-image: url(~@/assets/images/slogen-4.png);        
    }


    .m-match-place .container{
        display: flex;
        justify-content: center;
        margin-top: 40px;
    }

    .m-match-place .p-1{
        width: 659px;
        height: 292px;
        margin: 0 40px;
        background-image: url(~@/assets/images/bg-match-info-1.png);
    }

    .m-match-place .p-2{
        width: 659px;
        height: 292px;
        margin: 0 40px;
        background-image: url(~@/assets/images/bg-match-info-2.png);
    }
    
    .links{
        display: flex;
        justify-content: center;
        margin-top: 70px;
    }

    .u-btn a{
        display: block;
        width: 100%;
        height: 100%;
    }

    .u-btn.link-place{
        width: 450px;
        height: 74px;
        margin: 0 15px;
        background-image: url(~@/assets/images/btn-address.png);
    }

    .u-btn.link-place:hover{
        background-image: url(~@/assets/images/btn-address_hover.png);
    }

    .u-btn.link-rule{
        width: 450px;
        height: 74px;
        margin: 0 15px;
        background-image: url(~@/assets/images/btn-rule.png);
    }

    .u-btn.link-rule:hover{
        background-image: url(~@/assets/images/btn-rule_hover.png);
    }

    .match-team-img{
        margin-top: 115px;
    }
    
    .match-team-img .img{
        width: 1238px;
        height: 429px;
        margin: 0 auto;
        background-image: url(~@/assets/images/img-team-info.png);
    }
</style>

<script>
export default {
    data () {
        return {
            timeline  : [],
        }
    },
    created (){
        this.render();
    },
    methods : {
        render (){
            this.$axios.get(this.$ajax_url_map.timeline)
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    this.timeline = res.data.data
                }
                else{
                    this.$message.error('赛事时间轴模块：数据请求失败，请稍后再试');
                }
            });
        },
        dateFtt(fmt,date){
            var o = { 
                "M+" : date.getMonth()+1,     //月份 
                "d+" : date.getDate(),     //日 
                "h+" : date.getHours(),     //小时 
                "m+" : date.getMinutes(),     //分 
                "s+" : date.getSeconds(),     //秒 
                "q+" : Math.floor((date.getMonth()+3)/3), //季度 
                "S" : date.getMilliseconds()    //毫秒 
            }; 
            if(/(y+)/.test(fmt)) 
            fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length)); 
            for(var k in o) 
            if(new RegExp("("+ k +")").test(fmt)) 
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length))); 
            return fmt;             
        },
        crtTimeFtt(value,row,index){
            var crtTime = new Date(value);
            return this.dateFtt("MM.dd",crtTime);//直接调用公共JS里面的时间类处理的办法             
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/matchInfo.vue